/**
 * @module http adapter
 *
 * Expose a "fetch api" interface and encapsulate the concerns of polyfilling
 * that interface if it doesn't exist and/or using a different library, as well
 * as some error handling related to HTTP at a high level for sending back more
 * meaningful error responses. Provides a `request` function along with some
 * network response codes (in case callers want to look up certain codes).
 */
import 'whatwg-fetch';
import * as log from './log';

const fetch = window.fetch;

const SUCCESS = 200;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const FORBIDDEN = 403;
const CONFLICT = 409;
const NOT_FOUND = 404;
const UNPROCESSABLE = 422;
const GENERIC_ERROR = 500;

const errorCodes = {
  BAD_REQUEST,
  UNAUTHORIZED,
  FORBIDDEN,
  CONFLICT,
  NOT_FOUND,
  UNPROCESSABLE,
  GENERIC_ERROR,
};

const codes = {
  SUCCESS,
  ...errorCodes,
};

/**
 * Switch on error codes to provide specific error responses that can
 * be handled by the app in a predictable way (i.e., without requiring
 * implementation knowledge of how the specific http mechanism works in
 * case we want to do different things like graphql or axios or fetch).
 */
const createHttpError = (code, msg) => {
  return {
    code,
    message: msg,
  };
};

const request = async (url, options = {}) => {
  try {
    const res = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      ...options,
    });

    log.debug('successful response: ', res);

    return res;
  } catch (err) {
    // TODO: handle http error (only check http error codes at this level, genericly)
    log.error('unable to make request: ', err);

    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    throw createHttpError(err.code, err.msg);
  }
};

export { request, codes, errorCodes };
